/**
 * Prices are deliberately not published on this site. Every position that
 * would otherwise render a property's price, per-sq-ft rate or unit price
 * shows this instead, so the wording is identical everywhere and changing it
 * is a one-line edit.
 *
 * Scope note: this covers a PROPERTY's own price. It intentionally does not
 * apply to the budget filters or the calculator tools — those show amounts the
 * visitor chose or typed, not a figure we're quoting them.
 */
export const PRICE_ON_REQUEST = 'Price on request';
